<template>
  <div class="theme-input hrm_input">
   <label
      class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400"
      >
      {{ trans("lang.labels.resource_type") }}
    </label>

    <VueMultiselect
      v-model="filterData.resource_type"
      :options="resourceTypes"
      label="title"
      valueProp="value"
      mode="single"
        class="hrm-vuemultiselect"
      :placeholder="trans('lang.labels.Select')"
      @select="onResourceTypeChange"
    />
  </div>

  <div class="hrm_input" v-if="!loadingResources">
   <label
      class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400"
      >
      {{ trans("lang.labels.Event") }}
    </label>

    <VueMultiselect
      v-model="filterData.resource_id"
      :options="resourceList"
      label="title"
      valueProp="id"
      mode="single"
        class="hrm-vuemultiselect"
      :placeholder="trans('lang.labels.Select')"
      @select="onResourceSelect"
    />

  </div>
</template>
<script>
import axios from "axios";
import { mapStores } from "pinia";
import { useAppStore } from "@/store";
import VueMultiselect from "@vueform/multiselect";

import customFieldInjectorMixin from "@/../../Modules/CustomField/Resources/js/mixins/customFieldInjectorMixin";
import { setListData, reminderResourceType } from "@/helpers/Reminder";

export default {
  name: "AddLocation",

  mixins: [customFieldInjectorMixin],

  components: { VueMultiselect },

  props: {
    filterData: {
      type: Object,
      required: true,
    },
    filterItem: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: {
        resource_type: null,
        resource_id: null,
      },
      errors: {},
      resourceList: [],
      loadingResources: false,
    };
  },

  computed: {
    ...mapStores(useAppStore),

    resourceTypes() {
      return reminderResourceType.filter((item) => checkPermission(item.permission));
    },
  },

  methods: {
    async onResourceTypeChange(value) {
      this.resourceList = [];
      this.filterData.resource_id = null;
      this.loadingResources = true;

      const [url, titleKey, queryData, idKey] = setListData(value);

      if (!url) {
        this.loadingResources = false;
        return;
      }

      try {
        const { data } = await axios.get(url, { params: queryData });

        this.resourceList = (data.data || []).map((item) => ({
          id: item[idKey],
          title: item[titleKey],
        }));
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingResources = false;
      }
    },
  },
};
</script>
